<template>
  <div id="Home">
    <HeroSlider />
    <Benefits />
    <!-- <Plans /> -->
    <!-- <Preset /> -->
    <Create />
    <!-- <Preset /> -->
    <!-- <Options /> -->
    <!-- <Seats /> -->
    <!-- <Ready /> -->
    <!-- <SeatingPricing /> -->
    <!-- <Schedule /> -->
    <BookSuiteForm />
    <Modal :modalActive="modalActive" @modalHide="modalHide" />
  </div>
</template>

<script>
import HeroSlider from "@/components/HeroSlider";
import Benefits from "@/components/Benefits/Benefits";
// import Options from "@/components/Options/Options";
// import Seats from "@/components/Seats/Seats";
// import SeatingPricing from "@/components/SeatingPricing/SeatingPricing";
// import Schedule from "@/components/Schedule/Schedule";
import BookSuiteForm from "@/components/BookSuiteForm/BookSuiteForm";
// import Plans from "@/components/Plans/Plans";
// import Preset from "@/components/Plans/Preset.vue";
import Create from "@/components/Plans/Create.vue";
// import Preset from "@/components/Plans/Preset.vue"
import Modal from "@/components/global/Modal.vue"
// import Ready from "@/components/Ready/Ready.vue";

export default {
  name: "Home",
  components: {
    HeroSlider,
    Benefits,
    // Plans,
    // Options,
    // Seats,
    // SeatingPricing,
    // Schedule,
    BookSuiteForm,
    // Ready,
    // Preset,
    Modal,
    Create,
    // Preset,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      modalActive: false,
    };
  },
  mounted() {
    let that = this;
    window.addEventListener(
      "resize",
      function () {
        that.windowWidth = window.innerWidth;
      },
      false
    );
  },
  computed: {
  },
  methods: {
    modalHide() {
      this.modalActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#Home {
  overflow: hidden;
}
</style>
